export default __webpack_public_path__ + "src/images/reports/fmc-kataster-ki-meldedialog-dankescreen-01.jpg";